module.exports = __webpack_public_path__ + "img/clock-rotate-left.6312e0ec.svg";